var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',[_c('v-card',[_c('v-card-title',[_vm._v(" asss fund allocation frief ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }